import {Component, OnInit} from '@angular/core';
import {SidebarService} from "../../services/sidebar.service";
import {StateService} from "../../services/state.service";
import {Router} from "@angular/router";
import {UtilService} from "../../services/util.service";
import {UserStatus} from "../../models/user";
import {HttpHeaders} from "@angular/common/http";
import {HttpService} from "../../services/http.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  UserStatus: typeof UserStatus = UserStatus;

  constructor(public util : UtilService,
              public sidebarService:SidebarService,
              public stateService : StateService,
              private router: Router,
              private httpService: HttpService) { }

  ngOnInit(): void {
  }

  onToggleDrawer() {
    this.sidebarService.toggle();
  }

  onManageUserProfile() {
    this.router.navigate(['/user/profile'] );
  }

  onLogout() {
    setTimeout (() => {
      this.util.displayDialogMessage("Logging out", "This will log you out of EPDS",
        {subtitle: "Are you sure you wish to logout", confirmText: "Yes", cancelBtn: true})
        .subscribe(res => {
          if (res) {
            this.stateService.doLogout();
          }
        });
    }, 0);
  }

  onUserGuide(guide?: string) {
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    const options = { observe: 'response', 'responseType': 'blob' as 'json', ...headers };
    let vars = "";
    if (guide) vars += '?guideType=' + guide;

    window.open(this.util.getBaseURL() + "/epds/user-guides" + vars, '_blank');

    // this.httpService.Get<any>('/user-guides' + vars, options).subscribe(response => {
    //   const contentType = response.headers.get('content-type');
    //   const fileName = response.headers.get('content-disposition').split(';').map((h: string) => h.trim())
    //     .filter((h: string) => h.startsWith('filename='))
    //     .reduce((h: string | any[]) => h.length === 1 ? h[0] : 'file.pdf')
    //     .replace('filename=', '');
    //
    //   const file = new File([response.body], fileName, {type: contentType});
    //   const url= URL.createObjectURL(file);
    //   window.open(url, '_blank');
    // });
  }

  onBestPractice() {
    this.onUserGuide("bestPractices");
  }

  onInstructions() {
    this.onUserGuide("instructions");
  }

  onFAQ() {
    this.onUserGuide("faq");
  }

  onContactUs() {
    setTimeout (() => {
      this.util.displayDialogMessage("Contact Us",
        "If you have questions or Section 508 needs, please contact GAO at 202-512-5436,<br>" +
        "or email at <a href='mailto:protests@gao.gov'>protests@gao.gov</a>");
    }, 0);
  }

  onFeedback() {
    setTimeout (() => {
      this.util.displayDialogMessage("Send Feedback",
        "To provide your feedback on how we can improve EPDS, please email us at <a href='mailto:epdsfeedback@gao.gov'>epdsfeedback@gao.gov</a>.<br>" +
        "<b>Do not use this email account to communicate with GAO regarding pending or prospective protests.</b>");
    }, 0);
  }

}
